import VueI8n from '@/i18n/locale'
import ruleConfig from './rules-CR'

export default {
  ...ruleConfig,
  multiplePhones (mask = '', { gettext, sprintf }, payload) {
    const [max] = payload
    return {
      rules: {
        custom: value => (value && max ? value.split(',').length <= max : true),
        pattern: /^(8[0234]9\d{7})(,8[0234]9\d{7})*$/
      },
      messages: {
        custom: max ? `${mask}${sprintf(gettext('最多%d个'), max)}` : '',
        pattern: VueI8n.t('FoodB_Launch_Illegal_import_jlOS' /** 输入非法 */)
      }
    }
  }
}
